import clsx from 'clsx';
import { useMemo } from 'react';
import {
  Modal as ReactAriaModal,
  ModalOverlay as ReactAriaModalOverlay,
  ModalOverlayProps as ReactAriaModalOverlayProps,
} from 'react-aria-components';
import { ModalDialogContext } from './ModalDialogContext';
import styles from './OverlayBase.module.scss';

type OverlayBaseProps = ReactAriaModalOverlayProps;

/**
 * Base wrapper around React Aria's `ModalOverlay` and `Modal`components. Customizations to the overlay (i.e. the darkened background) can theoretically be applied here.
 * @private
 */
export const OverlayBase = ({
  children,
  className,
  isDismissable = true,
  isOpen,
  onOpenChange,
  ...props
}: OverlayBaseProps) => {
  const contextValue = useMemo(() => ({ isDismissable }), [isDismissable]);

  return (
    <ModalDialogContext.Provider value={contextValue}>
      <ReactAriaModalOverlay
        className={styles.modalOverlay}
        data-zds
        isDismissable={isDismissable}
        isOpen={isOpen}
        isKeyboardDismissDisabled={!isDismissable}
        onOpenChange={onOpenChange}
        {...props}
      >
        <ReactAriaModal
          className={(renderProps) => {
            const dynamicClassName =
              typeof className === 'function'
                ? className(renderProps)
                : className;
            return clsx(styles.modal, dynamicClassName);
          }}
          data-zds
        >
          {children}
        </ReactAriaModal>
      </ReactAriaModalOverlay>
    </ModalDialogContext.Provider>
  );
};
